export default "__VITE_ASSET__B7Msb8vQ__"